import { createActions, createReducer } from 'reduxsauce'

import DetalhesRecursoConcedidoService from '../../servicos/DetalhesRecursoConcedidoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDetalhesRecursoConcedidoInicio: [],
    buscaDetalhesRecursoConcedidoSucesso: ['detalhesRecursoConcedido'],
    buscaDetalhesRecursoConcedidoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    resultado: [],
}

// Ação para busca completa
Creators.buscaDetalhesRecursoConcedido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaDetalhesRecursoConcedidoInicio())
        let serv = new DetalhesRecursoConcedidoService()
        return serv
            .consultarDetalhes(filtro)
            .then(response => dispatch(Creators.buscaDetalhesRecursoConcedidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDetalhesRecursoConcedidoErro(error)))
    }
}

const buscaDetalhesRecursoConcedidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaDetalhesRecursoConcedidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaDetalhesRecursoConcedidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, resultado: action.detalhesRecursoConcedido, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DETALHES_RECURSO_CONCEDIDO_INICIO]: buscaDetalhesRecursoConcedidoInicio,
    [Types.BUSCA_DETALHES_RECURSO_CONCEDIDO_ERRO]: buscaDetalhesRecursoConcedidoErro,
    [Types.BUSCA_DETALHES_RECURSO_CONCEDIDO_SUCESSO]: buscaDetalhesRecursoConcedidoSucesso,
})
